import { useEffect, useState } from 'react';
import Alert from './Alert.js';
import dashboardService from '../../services/DashboardService.js';
import { useAuth } from '../../context/AuthContext.js';
import {
  agentSwitchLoaderText,
  agentSwitchReadyText,
  clearAgentEnvironmentBoot,
  readAgentEnvironmentBoot,
} from '../../utils/agentSwitchBoot.js';

export default function AgentSwitchBoot() {
  const { user, loading } = useAuth();
  const [boot, setBoot] = useState(() => readAgentEnvironmentBoot());

  useEffect(() => {
    const onStart = (event) => setBoot(event.detail);
    const onClear = () => setBoot(null);
    window.addEventListener('essaar-agent-switch', onStart);
    window.addEventListener('essaar-agent-switch-clear', onClear);
    return () => {
      window.removeEventListener('essaar-agent-switch', onStart);
      window.removeEventListener('essaar-agent-switch-clear', onClear);
    };
  }, []);

  useEffect(() => {
    if (!boot || boot.pending || loading || !user) return undefined;
    let active = true;
    const finish = () => {
      if (!active) return;
      const ready = agentSwitchReadyText(boot);
      clearAgentEnvironmentBoot();
      setBoot(null);
      Alert.success(ready, 5000);
    };
    dashboardService.getShipments({ page: 1, per_page: 1 })
      .then(finish)
      .catch(finish);
    return () => {
      active = false;
    };
  }, [boot, loading, user]);

  if (!boot) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-white/95 flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-5" />
        <p className="text-lg font-semibold text-gray-900">{agentSwitchLoaderText(boot)}</p>
        <p className="text-sm text-gray-500 mt-2">Please wait until the application is ready.</p>
      </div>
    </div>
  );
}
